<template>
    <div class="q_input">
        <div class="info_txt full">
            <div class="bx_input_wrap">
                <TextArea
                    ref="input"
                    :id="`q${questionIndex}`"
                    :placeholder="$t('EnrolmentQuestionEditor_inputQuestion')"
                    :maxlength="300"
                    @keydown.enter.prevent.stop="focusProgram(0)"
                    cols="50"
                    rows="1"
                    label-class="input_lbl"
                    label-tag="label"
                    :resize="true"
                    :one-line="true"
                    v-model="question"
                />
                <ul class="b_area">
                    <li>
                        <ImageUpload
                            v-slot="{openFileDialog}"
                            v-on:requestUpload="uploadImage"
                            v-ga-helper:click="gaImageUpload"
                        >
                            <button type="button" class="btn" @click.prevent="openFileDialog">
                                {{$t('EnrolmentQuestionEditor_addImage')}}
                            </button>
                        </ImageUpload>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bx_include_file type2" v-if="showImage">
            <div class="image">
                <img :src="image.url" alt="" style="max-width: 100%">
                <button type="button" class="btn_delete" v-on:click.prevent="deleteImage(questionIndex)"><span
                    class="sp">{{$t('EnrolmentQuestionEditor_deleteImage')}}</span></button>
            </div>
        </div>
        <div class="box_option">
            <div class="box_input_wrap">
                <strong class="tit">{{$t('EnrolmentQuestionEditor_choseCount')}}</strong>
                <i18n path="EnrolmentQuestionEditor_maxChosePrograms" tag="div" class="cont">
                    <template v-slot:dropdown>
                        <CustomSelect
                            class="bx_sorting3"
                            :options="select.maxChoice.options"
                            :input-props="select.maxChoice.inputProps"
                            v-model="maxChoice"
                            v-ga-helper:input.vueEvent="gaMaxChoice"
                        />
                    </template>
                </i18n>
                <div v-if="!isEnrolmentTypeDrawPrior" class="bx_input_wrap">
                    <span class="bx_input_chk">
                        <input type="checkbox" class="input_chk type5" id="sel"
                               :checked="isNotAllowDuplicateApply"
                               @input="toggleAllowDuplicateApply"
                               :disabled="isShowDrawPriors">
                        <label for="sel" class="input_lbl">{{$t('EnrolmentQuestionEditor_notAllowDuplicateApply')}}</label>
                    </span>
                    <span class="sp ico_help">
                        {{$t('EnrolmentQuestionEditor_notAllowDuplicateApplyTooltip')}}
                        <span class="ly_tooltip_wrap" style="width:271px">
                            <span class="desc_txt">{{$t('EnrolmentQuestionEditor_notAllowDuplicateApplyTooltipDesc1')}}
                                <br>({{$t('EnrolmentQuestionEditor_notAllowDuplicateApplyTooltipDesc2')}})</span>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <div class="input_list">
            <div class="tit_input">
                <strong class="tit">
                    {{$t('EnrolmentQuestionEditor_programList')}}
                </strong>
                <p class="dsc txt_error" v-html="$t('EnrolmentQuestionEditor_programListMandatory')"/>
                <div class="add_class">
                    <a
                        href="#"
                        class="btn_input"
                        @click.prevent="addProgramBulk"
                        v-ga-helper:click="{
                            view_category: '수강신청프로그램',
                            view_area: '엑셀로강좌일괄추가',
                            view_label: '',
                        }"
                    >
                        {{$t('EnrolmentQuestionEditor_addProgramBulk')}}
                    </a>
                    <a
                        v-show="isShowDrawPriors"
                        href="#"
                        class="btn_input"
                        @click.prevent="addPreDrawBulk"
                        v-ga-helper:click="{
                            view_category: '수강신청프로그램',
                            view_area: '엑셀로선추첨대상자일괄추가',
                            view_label: '',
                        }"
                    >
                        {{$t('EnrolmentQuestionEditor_addDrawPriors')}}
                    </a>
                </div>
            </div>
            <template v-for="(program, index) in programs">
                <EnrolmentQuestionProgramEditor :key="'p'+program.programNo" ref="programEditor"
                                                :question-index="questionIndex" :program-index="index"
                                                @focusNextProgram="focusNextProgram(index)"
                />
            </template>

            <button class="btn_class_add" type="button" @click="addProgram">
                {{$t('EnrolmentQuestionEditor_addProgram')}}
            </button>
        </div>
        <div class="btn_txt">
            <button
                type="button"
                @click.prevent="copyQuestion"
                v-ga-helper:click="{
                    view_category: '수강신청프로그램',
                    view_area: '복사하기클릭',
                    view_label: '',
                }"
            >{{$t('EnrolmentQuestionEditor_copy')}}</button>
            <button
                v-if="isShowDelete"
                type="button"
                @click.prevent="deleteQuestion"
                v-ga-helper:click="{
                    view_category: '수강신청프로그램',
                    view_area: '삭제하기클릭',
                    view_label: '',
                }"
            >
                {{$t('EnrolmentQuestionEditor_delete')}}
            </button>
        </div>
    </div>
</template>

<script>
import CustomSelect from '@iamteacherpc/components/common/CustomSelect.vue';
import {mapFields, mapMultiRowFields} from 'vuex-map-fields';
import EnrolmentQuestionProgramEditor from '@iamteacherpc/components/editor/EnrolmentQuestionProgramEditor.vue';
import {mapActions} from 'vuex';
import {
    ADD_PROGRAM,
    COPY_QUESTION,
    DELETE_QUESTION,
    MAX_PROGRAM,
    SET_PROGRAMS,
    SET_QUESTION_DRAW_PRIORS,
    SET_ALLOW_DUPLICATE_APPLY,
} from '@common/store/modules/enrolment/editor.js';
import {requestAlert, requestConfirm, requestDrawPriorsBulk, requestExcelProgram} from '@iamteacherpc/utils/iframe.js';
import ImageUpload from '@iamteacherpc/components/common/ImageUpload.vue';
import {REQUEST_STATE} from '@iamteacherpc/consts/request.js';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@common/store/modules/common/editor/questionList.js';
import {DELETE_QUESTION_IMAGE, NAMESPACE, UPLOAD_QUESTION_IMAGE} from '@common/store/modules/survey/editor.js';
import TextArea from '@iamteacherpc/components/common/TextArea.vue';
import {ENROLMENT_TYPE} from '@common/consts/survey';

export default {
    name: 'EnrolmentQuestionEditor',

    components: {
        ImageUpload,
        EnrolmentQuestionProgramEditor,
        CustomSelect,
        TextArea,
    },

    props: {
        questionIndex: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            select: {
                maxChoice: {
                    options: [
                        {label: this.$t('common_noLimit'), value: 0},
                        {label: '2', value: 2},
                        {label: '3', value: 3},
                        {label: '4', value: 4},
                        {label: '5', value: 5},
                        {label: this.$t('common_inputBySelf'), value: '__INPUT__'},
                    ],
                    inputProps: {
                        id: 'max-choice',
                        onlyNumber: true,
                        maxLength: 3,
                        placeholder: this.$t('common_inputBySelf'),
                    },
                },
                grade: {
                    options: this.$store.state.enrolment.options.filterOptions.filters,
                },
            },
        }
    },

    computed: {
        ...mapMultiRowFields('enrolment', ['form.questions']),
        ...mapFields('enrolment', ['form.enrolmentType']),
        ...mapFields('enrolment', ['form.isAllowDuplicateApply']),
        ...createComputed('question'),
        ...createComputed('programs'),
        ...createComputed('image'),

        isEnrolmentTypeDrawPrior() {
            return this.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR;
        },

        showImage() {
            return this.image && this.image.uploadState === REQUEST_STATE.SUCCESS;
        },

        isShowDelete() {
            return this.questions.length > 1;
        },

        isShowDrawPriors() {
            return this.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR;
        },

        maxChoice: {
            get() {
                return this.getQuestion().maxChoice;
            },
            set(newValue) {
                this.getQuestion().maxChoice = newValue;
            },
        },

        isNotAllowDuplicateApply() {
            /**
             * DB 및 API 에서는 중복신청허용으로 저장
             * 화면 표시할때만 중복신청불가로 not처리 해서 표시
             */
            return !this.isAllowDuplicateApply;
        },
    },

    methods: {
        ...mapActions('enrolment', {
            storeDeleteQuestion: DELETE_QUESTION,
            storeCopyQuestion: COPY_QUESTION,
            storeAddProgram: ADD_PROGRAM,
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
            setPrograms: SET_PROGRAMS,
            setQuestionDrawPriors: SET_QUESTION_DRAW_PRIORS,
            setAllowDuplicateApply: SET_ALLOW_DUPLICATE_APPLY,
            storeUploadImage: UPLOAD_QUESTION_IMAGE,
            storeDeleteImage: DELETE_QUESTION_IMAGE,
        }),

        getQuestion() {
            return this.questions[this.questionIndex];
        },

        deleteQuestion() {
            this.stopListChange();

            requestConfirm({
                title: this.$t('EnrolmentQuestionEditor_confirmDeleteEnrolment'),
                okText: this.$t('common_confirm'),
                cancelText: this.$t('common_cancel')
            }).then(() => {
                this.storeDeleteQuestion(this.questionIndex);
            }).catch(() => {
                // do nothing
            }).finally(() => {
                this.listChange();
            });
        },

        copyQuestion() {
            this.storeCopyQuestion(this.questionIndex);
            this.$emit('copyQuestion');
        },

        addProgram() {
            if (this.programs.length === MAX_PROGRAM) {
                this.stopListChange();

                requestAlert({
                    title: this.$t('EnrolmentQuestionEditor_availableMaxProgram', {max: MAX_PROGRAM}),
                    okText: this.$t('common_confirm')
                }).then(() => this.listChange());

                return;
            }

            this.storeAddProgram({
                questionIndex: this.questionIndex
            });

            this.$nextTick(function () {
                this.focusProgram(this.programs.length - 1);
            });
        },

        focusQuestion() {
            this.$refs.input.focus();
        },

        focusProgram(index) {
            this.$refs.programEditor[index].focusProgram();
        },

        focusNextProgram(index) {
            if (index < this.programs.length - 1) {
                this.focusProgram(index + 1);
                return;
            }

            this.addProgram();
        },

        async addProgramBulk() {
            const programs = await requestExcelProgram({
                enrolmentType: this.enrolmentType,
                programs: this.programs,
                filters: this.select.grade.options,
                isAllowDuplicateApply: this.isAllowDuplicateApply,
            });

            this.setPrograms({
                questionIndex: this.questionIndex,
                programs: programs,
            });
        },

        async addPreDrawBulk() {
            for (let i = 0; i < this.programs.length; i++) {
                const program = this.programs[i];

                if (!program.programName) {
                    this.stopListChange();
                    await requestAlert({
                        title: this.$t('EnrolmentEditor_inputProgramNumberN', {
                            i: this.questionIndex + 1,
                            j: i + 1,
                        }),
                    });
                    this.listChange();
                    return;
                }
            }

            const drawPriors = await requestDrawPriorsBulk({
                programs: this.programs,
            });

            this.setQuestionDrawPriors({
                questionIndex: this.questionIndex,
                drawPriors,
            });
        },

        uploadImage(file) {
            this.storeUploadImage({
                question: this.getQuestion(),
                file: file,
            }).catch(e => {
                requestAlert({title: e.message, okText: this.$t('common_confirm')});
            });
        },

        deleteImage() {
            this.storeDeleteImage({
                question: this.getQuestion()
            });
        },

        gaImageUpload() {
            // enrolmentEditor
            return {
                view_category: '수강신청프로그램',
                view_area: '이미지첨부하기클릭',
                view_label: '',
            }
        },

        gaMaxChoice($event) {
            const selectedItem = this.select.maxChoice.options.find(option => option.value === $event);
            return {
                view_category: '수강신청프로그램',
                view_area: '강좌수선택옵션클릭',
                view_label: selectedItem ? selectedItem.label : '직접입력',
            };
        },

        toggleAllowDuplicateApply() {
            this.setAllowDuplicateApply({isAllowDuplicateApply: !this.isAllowDuplicateApply});
        },
    },
}

function createComputed(key) {
    return {
        [key]: {
            get() {
                return this.getQuestion()[key];
            },
            set(newValue) {
                this.getQuestion()[key] = newValue;
            }
        }
    }
}
</script>

<style scoped>

</style>
